export default "/assets/images/attic-video.febf7ebbdd5617c8.mp4";